
import axios from 'axios'
const DEBI_TYPES = [ //DEBI
    'DPSRRS',
    'OFRS', 
    'OFES',
    'RPRS',
    'VAS'
] as const;
  
// เพิ่ม interface สำหรับ type safety
interface EngagementData {
    company: string;
    companyId: string;
    email: string;
    date: string;
    team: string;
    [key: string]: any; // สำหรับ dynamic properties เช่น OFES_total, OFES_answer
}
  
interface ProcessedEngagementItem {
    company: string;
    email: string;
    total: number;
    answer: number;
    date: string;
    type: string;
    team: string;
}
  
const processEngagementData = (rawData: EngagementData[]): Record<string, ProcessedEngagementItem> => {
    const engagementIndexDay: Record<string, ProcessedEngagementItem> = {};

    for (const data of Object.values(rawData)) {
        for (const type of DEBI_TYPES) {
        const key = `${data.company}-${data.email}-${type}-${data.date}`;
        
        engagementIndexDay[key] = {
            company: data.company,
            email: data.email,
            total: data[`${type}_total`] || 0,
            answer: data[`${type}_answer`] || 0,
            date: data.date,
            type,
            team: data.team
        };
        }
    }

    return engagementIndexDay;
}

const headers = {
    'Content-Type': 'application/json',
    'x-api-key': '9bc17abc-bb19-4132-cccd-ac0c0412'
}

export const getCompany = async (company:string) => {
    //console.log("company",company)
    const response = await axios.post(`https://getcompany-bv43tjyzrq-uc.a.run.app`, {company:company}, {headers:headers})
    //console.log("response",response)
    return response.data
}

export const getTeamByCompany = async (company:string) => {
    
    const response = await axios.post(`https://getteamall-bv43tjyzrq-uc.a.run.app`, {company:company}, {headers:headers})
    return response.data
}

export const getByTeam = async (team_id:string) => {
    const response = await axios.post(`https://getteam-bv43tjyzrq-uc.a.run.app`, {team:team_id}, {headers:headers})
    return response.data
}

export const getExcelsDetail = async () => {

    const response = await axios.post(`https://getexceldetails-bv43tjyzrq-uc.a.run.app`, '', {headers:headers})
    return response.data
}

export const getUserAll = async (company:string) => {
    const response = await axios.post(`https://getuserall-bv43tjyzrq-uc.a.run.app`, {company:company}, {headers:headers})
    return response.data
}

export const getByUser = async (email:string) => {
    const response = await axios.post(`https://getuser-bv43tjyzrq-uc.a.run.app`, {email:email}, {headers:headers})
    return response.data
}

export const getByQuestion = async (question_id:any) => {
    const response = await axios.post(`https://getquestion-bv43tjyzrq-uc.a.run.app`, {id:question_id}, {headers:headers})
    return response.data
}

export const getCategory = async () => {
    const response = await axios.post(`https://getcategories-bv43tjyzrq-uc.a.run.app`, '', {headers:headers})
    return response.data
}

//เอาเฉพาะ company main
export const getQustionAll = async () => {
    const response = await axios.post(`https://getquestions-bv43tjyzrq-uc.a.run.app`, '', {headers:headers})
    return response.data
}

export const getHerePoint = async (company:string,statusrowValues: any[],date:string) => {
    const response = await axios.post(`https://getherepoint-bv43tjyzrq-uc.a.run.app`, {
        "where": [
          {"field": "company", "operator": "==", "value": company},  
          {"field": "statusrow", "operator": "in", "value": statusrowValues},
          {"field": "date", "operator": ">=", "value": date}
        ]
      }, {headers:headers})
     // console.log('response',response.data)
    return response.data
}

export const getEngagementIndexDay = async (company:string, startDate:string, endDate:string) => {
    try {
        const response = await axios.post(`https://getengagementindexday1row-bv43tjyzrq-uc.a.run.app`, {
            "where": [
              {"field": "company", "operator": "==", "value": company},
              {"field": "date", "operator": ">=", "value": startDate},
              {"field": "date", "operator": "<=", "value": endDate},
            ]
          }, {headers:headers})
        if (!response.data || Object.keys(response.data).length === 0) {
            return {};
        }
        
        // console.log('Engagement Index Day Data:', processEngagementData(response.data))
        return processEngagementData(response.data);
    } catch (error) {
        console.log('Error fetching engagement index day:', error);
        throw error;
    }
}
